module.exports = __webpack_public_path__ + "img/3-2-5.5b1bf1a4.png";